module.exports = __webpack_public_path__ + "img/03_uk.9a7dd883.svg";